import { render, staticRenderFns } from "./ManualBarcodeInput.vue?vue&type=template&id=2467d4c1"
import script from "./ManualBarcodeInput.vue?vue&type=script&lang=js"
export * from "./ManualBarcodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports